import { render, staticRenderFns } from "./previewBox.vue?vue&type=template&id=5c82fa34&"
import script from "./previewBox.vue?vue&type=script&lang=js&"
export * from "./previewBox.vue?vue&type=script&lang=js&"
import style0 from "./previewBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports